import styled from 'styled-components';

export const Wrapper = styled.div`
	background-color: ${({ theme }) => theme.colors.background.secondary};
	min-height: 130px;
	padding: 16px;
	border-radius: 12px;
`;

export const TitleRow = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	margin-bottom: 8px;
`;

export const ImageWrapper = styled.div`
	width: 46px;
	height: 46px;

	img {
		width: 100%;
		height: 100%;
	}
`;

export const Title = styled.h3`
	margin: 0;
	font-size: 20px;
	line-height: 27px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};

	@media (max-width: 992px) {
		font-size: 14px;
		line-height: 19px;
	}
`;

export const Description = styled.p`
	font-size: 16px;
	line-height: 22px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.body};

	@media (max-width: 992px) {
		font-size: 14px;
		line-height: 19px;
	}
`;
